const state = {
	clientsStatisticsData: {
		items: [],
		totals: 0
	}
}

export default state
